import { useElemasonFragmentContext } from "../contexts/ElemasonFragmentContext";

import type { ElemasonFragment, Nil } from "@tectonic/types";

const useFragmentValue = (fragment?: Nil<ElemasonFragment>) => {
  const fragmentContext = useElemasonFragmentContext();

  return (data?: unknown) => {
    if (!fragment) return fragmentContext;

    const value = {
      data,
      id: fragment.id,
      slug: fragment.slug,
      // TODO: deicde if we want to keep this
      stack: fragmentContext
        ? [
          {
            id: fragmentContext.id,
            slug: fragmentContext.slug,
            data: fragmentContext.data,
          },
          ...(fragmentContext.stack ?? []),
        ]
        : [],
    }

    return value;
  }
}

export { useFragmentValue };

